var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSortDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0006 7C12.5529 7 13.0006 7.44771 13.0006 8L13.0006 15.5381L15.2989 13.267C15.6888 12.8486 16.3202 12.8493 16.7092 13.2686C16.9034 13.478 17.0006 13.7522 17.0006 14.0263C17.0006 14.2554 16.9328 14.4844 16.7972 14.6756L16.7077 14.7855L14.4062 17.0597C13.7772 17.7362 12.9352 18.0477 12.1098 17.9941C12.0739 17.998 12.0375 18 12.0006 18C11.9636 18 11.9271 17.998 11.8911 17.9941C11.0657 18.0478 10.2234 17.7363 9.59442 17.0597L7.29284 14.7855L7.20336 14.6756C7.0678 14.4844 7 14.2554 7 14.0263C7 13.7522 7.09713 13.478 7.29139 13.2686C7.68041 12.8493 8.31181 12.8486 8.70167 13.267L11.0006 15.5386L11.0006 8C11.0006 7.44771 11.4483 7 12.0006 7Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortDown);
export default __webpack_public_path__ + "static/media/sort-down.cba105e826715424db56fa5e2bdf6163.svg";
export { ForwardRef as ReactComponent };